interface Iprops {
    color?: string;
}

export const VectorIcon = ({color}: Iprops) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7184 3.03047C14.073 1.17422 11.6789 0 9 0C4.02891 0 0 4.02891 0 9H2.25C2.25 5.26992 5.26992 2.25 9 2.25C11.0566 2.25 12.8813 3.18164 14.1152 4.63359L11.9988 6.75H18V0.748828L15.7184 3.03047ZM9 15.75C6.94336 15.75 5.11875 14.8184 3.88477 13.3664L6.00117 11.25H0V17.2512L2.28164 14.9695C3.92695 16.8258 6.32461 18 9 18C13.9711 18 18 13.9711 18 9H15.75C15.75 12.7301 12.7301 15.75 9 15.75Z" fill={color || "#FADB14"} />
    </svg>
);